import { getRequest, postRequest } from "../../utils/api";
import { useEffect, useState } from "react";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader/Loader";
import PaginationComponent from "../../Component/Pagination/pagination";
import moment from "moment";
import AffiliateCommissionModal from "./modal/AffiliateCommissionModal";

const AffiliateAccount = () => {
    const [showCommissionTierModal, setShowCommissionTierModal] = useState(false);

    const handleOpenCommissionTierModal = (affiliate: any) => {
        setAffiliateData(affiliate)
        setShowCommissionTierModal(true);
    }
    const handleCommissionTierCommissionTierModal = () => {
        fetchAffiliateList()
        setShowCommissionTierModal(false);
    }
    const [affiliateData, setAffiliateData] = useState<any>({});
    const [affiliateList, setAffiliateList] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalUsers, setTotalUsers] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [stats, setStats] = useState<any>({});
    const fetchAffiliateList = async () => {
        setLoading(true);
        try {
            const response = await getRequest(
                `/affiliate/affiliate-list?page=${page}&limit=10`
            );

            if (response.status === "success") {
                setAffiliateList(response.data);
                setStats(response.stats)
                setTotalPages(response.pagination.totalPages);
                setTotalUsers(response.pagination.total);
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Error fetching affiliates:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAffiliateList();
    }, [page]);

    const handleDirectLogin = async (userId: string) => {
        try {
          const response = await postRequest(`/affiliate/admin-login-as-affiliate`, { user_id: userId });
    
          if (response.status === 'success') {
            toast.success("Opening user dashboard...");
    
            // 👇 TEMPORARILY save the user data payload so the new tab can read it
            localStorage.setItem("temp_impersonate_data", JSON.stringify(response.data));
    
            // Open the new AutoLogin page in a NEW tab, passing the token
            window.open(`https://affiliates.uomox.com/auto-login?token=${response.token}`, '_blank');
    
          } else {
            toast.error(response.message || "Failed to login as this user");
          }
        } catch (error) {
          toast.error("Something went wrong during direct login.");
        }
      };
    return (
        <>
            {loading && (<Loader />)}
            <div className="hk-pg-wrapper">
                <div className="hk-pg-body py-0">
                    <div className="page-wrap">
                        <div className="page-content ps-0">
                            <div className="page-detail-wrap">
                                <header className="page-header">
                                    <div>
                                        <div className="page-title">
                                            <h2 className="mb-0">Affiliate Account</h2>
                                        </div>
                                    </div>
                                </header>
                                <div className="page-body">
                                    <div data-simplebar className="nicescroll-bar">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6 className="h2 mb-1">{stats?.totalAffiliates ?? 0}</h6>
                                                                    <p className="mb-1 text-muted fs-12">Total Affiliates</p>
                                                                </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6 className="h2 mb-1">{stats?.activeAffiliates ?? 0}</h6>
                                                                    <p className="mb-1 text-muted fs-12">Active Affiliates</p>
                                                                </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6 className="h2 mb-1">{stats?.totalConversions ?? 0}</h6>
                                                                    <p className="mb-1 text-muted fs-12">Total Conversion</p>
                                                                </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6 className="h2 mb-1">₹ {stats?.totalCommission ?? 0}</h6>
                                                                    <p className="mb-1 text-muted fs-12">Total Commission</p>
                                                                </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6 className="h2 mb-1">₹ {stats?.pendingPayout ?? 0}</h6>
                                                                    <p className="mb-1 text-muted fs-12">Pending Payout</p>
                                                                </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div>
                                                                <h6 className="mb-0">Affiliate accounts lists</h6>
                                                                <p className="mb-0 text-muted fs-12">Monitor Earnings, Payouts & Conversions</p>
                                                            </div>
                                                        </div>
                                                        <div className="table-responsive">
                                                            <table className="table table-hover mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>ID</th>
                                                                        <th>Affiliate</th>
                                                                        <th className="text-center">Commission Tier</th>
                                                                        <th className="text-center">Client / Users</th>
                                                                        <th className="text-center">Click</th>
                                                                        <th className="text-center">Commission / Earning</th>
                                                                        <th>Performance</th>
                                                                        <th>Joined</th>
                                                                        <th className="text-center">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {affiliateList && affiliateList.length > 0 ? (
                                                                        affiliateList.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>#{item.affiliate_unique_id}</td>
                                                                                <td>
                                                                                    <div className="media align-items-center">
                                                                                        <div className="media-head me-2">
                                                                                            <div className="avatar avatar-xss rounded">
                                                                                                <img src="/dist/img/logo-avatar-3.png" alt="user" className="avatar-img" />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="media-body">
                                                                                            <h6 className="fs-13 mb-0 eclps-name-175">{item.affiliate_first_name + ' ' + item.affiliate_last_name}</h6>
                                                                                            <p className="mb-0 fs-12">{item.affiliate_email}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="text-center" onClick={(e) => handleOpenCommissionTierModal(item)}>{item.affiliate_referral_commission_data ? item.affiliate_referral_commission_data.commission_title : '-'}</td>
                                                                                <td className="text-center">{item.total_user}</td>
                                                                                <td className="text-center">{item.affiliate_referral_hits}</td>
                                                                                <td className="text-center">₹{item.total_commission}</td>
                                                                                <td><span className="eclps-name-100">-</span></td>
                                                                                <td>{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                                                                <td className="text-center">
                                                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                                                        <div className="d-flex gap-1">
                                                                                            <a className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" data-bs-toggle="tooltip" data-placement="top" title="" data-bs-original-title="View" href="#" >
                                                                                                <span className="icon">
                                                                                                    <i className="ri-eye-line"></i>
                                                                                                </span>
                                                                                            </a>
                                                                                            <div className="dropdown dropdown-static">
                                                                                                <button className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover dropdown-toggle no-caret" aria-expanded="false" data-bs-toggle="dropdown">
                                                                                                    <span className="icon">
                                                                                                        <i className="ri-more-2-fill"></i>
                                                                                                    </span>
                                                                                                </button>
                                                                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                                                                    <a
                                                                                                        className="dropdown-item"
                                                                                                        href="#"
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            handleDirectLogin(item._id);
                                                                                                        }}
                                                                                                    >
                                                                                                        <span className="dropdown-icon"><i className="ri-login-circle-line text-primary"></i></span>
                                                                                                        <span>Login as User</span>
                                                                                                    </a>
                                                                                                    <a
                                                                                                        className="dropdown-item"
                                                                                                        href="#"
                                                                                                    >
                                                                                                        <span className="dropdown-icon"><i className="ri-vip-crown-line"></i></span>
                                                                                                        <span>Edit</span>
                                                                                                    </a>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan={10}>
                                                                                <div className="text-center">No Record Found</div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="card-footer d-flex justify-content-between align-items-center">
                                                            <div className="col-sm">
                                                                <div className="text-muted">Showing <span className="fw-semibold">{affiliateList?.length || 0}</span> of <span className="fw-semibold">{totalUsers || 0}</span> Results</div>
                                                            </div>
                                                            {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AffiliateCommissionModal
                show={showCommissionTierModal}
                onHide={handleCommissionTierCommissionTierModal}
                affiliateData={affiliateData}
            />
        </>

    )
}
export default AffiliateAccount